export enum ScoreType {
    ARM = "ARM",
    ISIP = "ISIP"
  }